

































import { Component, Prop, Emit, Vue } from "vue-property-decorator";
import DatepickerComponent from "@/components/packages/datepicker/DatepickerComponent.vue";
import { DatepickerElement } from "@/typescript/packages/datepicker/types";
export { DatepickerElement };

@Component({
  components: {
    DatepickerComponent
  }
})
export default class CalendarComponent extends Vue {
  $refs!: {
    datepicker: DatepickerElement;
  };

  @Prop()
  width!: string;

  @Prop({
    default: "100px"
  })
  datepickerWidth!: string;

  @Prop({
    default: false
  })
  hasError!: boolean;

  @Prop({
    default: false
  })
  imageLeft!: boolean;

  @Prop()
  value!: string;

  @Prop({
    default: "day"
  })
  minView!: "year" | "month" | "day";

  @Prop({
    default: "yyyy/MM/dd"
  })
  format!: string;

  @Prop({
    default: "YYYY/MM/DD"
  })
  outputFormat!: string;

  @Prop({
    default: false
  })
  isDisabled!: boolean;

  @Emit()
  change(value: string) {
    return value;
  }

  handleChange(value) {
    this.change(value);
  }

  openCalendar() {
    if (!this.$refs.datepicker) return;
    this.$refs.datepicker.showCalendar();
  }
}
